/* eslint no-console:0 */

/**
 * Handles back to top button
 * @module toggleReveal
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

export const PLUGIN_NAME = 'toggleReveal';
export const DEFAULTS = {
};

const makeDisableFocus = (toggleContainer, toggleButton) => () => {
  toggleContainer.find('a').not(toggleButton).attr('tabindex', -1);
};

const makeEnableFocus = (toggleContainer, toggleButton) => () => {
  const anchors = toggleContainer.find('a');
  anchors.not(toggleButton).attr('tabindex', 0);
  anchors.first().focus();
};

const updateButtonCopy = (toggleButton) => {
  const currentText = toggleButton.find('.action-button__copy').text();
  const newToggleText = toggleButton.data('close-copy');
  toggleButton.data('close-copy', currentText).find('.action-button__copy').text(newToggleText);
};

const makeHandleReveal = (toggleButton, toggleContainer, disableFocus, enableFocus) => () => {
  const redirectUrl = toggleButton.data('url');
  const loadProductURL = toggleButton.data('load-product-url');

  if (!toggleContainer.hasClass('active')) {
    if (toggleButton.hasClass('js-slidedown--toggle-display')) {
      toggleButton.hide();
    }
    toggleContainer.addClass('active');
    updateButtonCopy(toggleButton);
  } else {
    // Check if toggleButton has data-url
    if (redirectUrl) {
      if (toggleButton.prop('tagName').toLowerCase() === 'button') {
        const btnURL = `window.location = '${redirectUrl}'`;
        toggleButton.attr('onClick', btnURL).trigger('click');
      } else { // assumes it's an anchor tag
        toggleButton.attr('href', redirectUrl);
      }
    }
    // Check if toggleButton has data-load-product-url
    if (loadProductURL && toggleContainer.hasClass('active')) {
      // Get last Product before the AJAX load
      const lastProduct = toggleContainer.find('.js-plp-container').last();
      $.ajax({
        url: loadProductURL,
        success: (response) => {
          toggleContainer.append(response);
        },
        complete: () => {
          toggleButton.data('load-product-url', false); // sets the false value
          toggleButton.attr('data-load-product-url', false); // Visually changes the copy to "false"
          toggleButton.data('close-copy', 'view more');
          toggleButton.data('expand-copy', 'view less');
          toggleButton.find('.action-button__copy').text('view less');
          // Use the last product before the ajax load and focus on it
          lastProduct.find('a').first().focus();
          $('.js-lazy-image').lazy();
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.error(`${textStatus} ${errorThrown}`);
        },
      });
    }
    // Check if toggleButton has No data-load-product-url and No data-url
    if (!loadProductURL && !redirectUrl) {
      toggleContainer.toggleClass('active');
      updateButtonCopy(toggleButton);
    }
  }

  if (toggleContainer.hasClass('active')) {
    enableFocus();
  } else {
    disableFocus();
  }
};

export default function toggleReveal() {
  const toggleButton = $('.js-toggle-reveal');
  const toggleContainer = $('.js-toggle-reveal-trigger');
  const disableFocus = makeDisableFocus(toggleContainer, toggleButton);
  const enableFocus = makeEnableFocus(toggleContainer, toggleButton);
  const handleReveal = makeHandleReveal(toggleButton, toggleContainer, disableFocus, enableFocus);

  disableFocus();
  toggleButton.on('click', handleReveal);
}

registerJQueryPlugin(PLUGIN_NAME, toggleReveal);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/toggle-reveal.js